module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/angle-up-34c103453f70adbcd8a59515d7020185.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/angle-up.svg
// module id = psgh
// module chunks = 24